import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ContactRenderHelper } from "@/Common/Helpers/ContactRenderHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";

interface IEmailsViewProps {
    doNotEmail: boolean;
    emails: Email[];
}

function EmailsView(props: IEmailsViewProps): JSX.Element {
    const { getText } = useTranslation();

    const doNotEmailView: JSX.Element = (
        <div className="flex-container" style={{ justifyContent: "flex-start" }}>
            <div>
                <span>{getText("EmailLabel")}</span>
            </div>
            <div style={{ marginLeft: "90px" }}>
                <strong> {getText("DoNotEmailLabel")}</strong>
            </div>
        </div>
    );

    const listView: JSX.Element = (
        <>
            {props.emails.map(email => (
                <tbody key={`email_${email.ContactPoint_id}`}>
                    {ContactRenderHelper.renderRow(
                        getText("TypeLabel"),
                        cacheStore.GetLocalizedValueByLookupId(email.ContactPointTypeLookupId),
                        "patientProfile-contacts-email-type"
                    )}
                    {ContactRenderHelper.renderRow(
                        getText("AddressLabel"),
                        <a href={"mailto:" + email.Address}>{MyleHelper.ReplaceEmptyString(email.Address)}</a>,
                        "patientProfile-contacts-email-address"
                    )}
                    {ContactRenderHelper.renderRow(
                        null,
                        email.NotificationsEnabled && (
                            <CheckboxControl
                                dataCy="patientProfile-contacts-email-notifiable"
                                disabled
                                id={"chkEmail" + email.ContactPoint_id}
                                checked={email.NotificationsEnabled}
                                label={getText("NotifyPatientLabel")}
                            />
                        ),
                        "patientProfile-contacts"
                    )}
                </tbody>
            ))}
        </>
    );

    const emailView: JSX.Element = (
        <>
            <div><span>{getText("EmailLabel")}</span></div>
            <div>
                <table>
                    {props.emails.any() ? listView : ContactRenderHelper.renderEmptyView("emails")}
                </table>
            </div>
        </>
    );

    return props.doNotEmail ? doNotEmailView : emailView;
}

export { EmailsView };
